import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
export var HeaderUserDetails =
/*#__PURE__*/
function (_Component) {
  _inherits(HeaderUserDetails, _Component);

  function HeaderUserDetails() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HeaderUserDetails);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HeaderUserDetails)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          mediaQueryLg = _this$props.mediaQueryLg,
          onDropdownStateToggled = _this$props.onDropdownStateToggled;

      if (!mediaQueryLg) {
        event.preventDefault();
        onDropdownStateToggled();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      var _this$props2 = _this.props,
          mediaQueryLg = _this$props2.mediaQueryLg,
          onDropdownStateToggled = _this$props2.onDropdownStateToggled;

      if (mediaQueryLg) {
        _this.timer = setTimeout(onDropdownStateToggled, 750);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      var _this$props3 = _this.props,
          mediaQueryLg = _this$props3.mediaQueryLg,
          dropdownOpen = _this$props3.dropdownOpen,
          onDropdownStateToggled = _this$props3.onDropdownStateToggled;
      clearTimeout(_this.timer);

      if (mediaQueryLg && !dropdownOpen) {
        onDropdownStateToggled();
      }
    });

    return _this;
  }

  _createClass(HeaderUserDetails, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          dropdownOpen = _this$props4.dropdownOpen,
          mediaQueryLg = _this$props4.mediaQueryLg,
          avatarUrl = _this$props4.avatarUrl,
          firstName = _this$props4.firstName,
          children = _this$props4.children;
      return React.createElement("div", {
        className: "header__dropdown",
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, React.createElement("div", {
        className: classNames('header__dropdown__target', {
          'header__dropdown__target--open': dropdownOpen
        })
      }, React.createElement("div", {
        className: "header__dropdown__avatar"
      }, avatarUrl ? React.createElement("img", {
        src: avatarUrl,
        alt: "user avatar"
      }) : React.createElement("span", null, (firstName || '').slice(0, 1))), React.createElement(Isvg, {
        className: "header__dropdown__arrow svg",
        uniquifyIDs: false,
        src: require('../../../static/img/arrow.svg')
      })), dropdownOpen && mediaQueryLg && children && React.createElement("div", {
        className: "header__dropdown__panel"
      }, children));
    }
  }]);

  return HeaderUserDetails;
}(Component);
HeaderUserDetails.propTypes = {
  avatarUrl: PropTypes.string,
  children: PropTypes.node,
  dropdownOpen: PropTypes.bool,
  firstName: PropTypes.string,
  mediaQueryLg: PropTypes.bool,
  onDropdownStateToggled: PropTypes.func.isRequired
};